import flourite from "flourite"
import { toHtml } from "hast-util-to-html"
import { refractor } from "refractor"
import graphql from "refractor/lang/graphql.js"
import haskell from "refractor/lang/haskell.js"
import jsx from "refractor/lang/jsx.js"
import ocaml from "refractor/lang/ocaml.js"
import toml from "refractor/lang/toml.js"
import tsx from "refractor/lang/tsx.js"
import zig from "refractor/lang/zig.js"

refractor.register(zig)
refractor.register(ocaml)
refractor.register(jsx)
refractor.register(tsx)
refractor.register(toml)
refractor.register(haskell)
refractor.register(graphql)

export function detectLanguage({ code }: { code: string }) {
  // @ts-ignore
  return flourite(code, { shiki: true, noUnknown: true }).language
}

export function highlight({
  code,
  language,
}: {
  code: string
  language?: string
}): any {
  if (!language || !refractor.registered(language)) return null

  return refractor.highlight(code, language)?.children
}

export function highlightHtml({
  code,
  language,
}: {
  code: string
  language?: string
}) {
  const nodes = highlight({ code, language })
  if (!nodes) return code

  // TODO: use hast-util-sanitize
  return toHtml(nodes as any)
}

export function hastToHtml(hast: any) {
  return toHtml(hast)
}
